import { styled, Box } from '@mui/material';
import { pxToRem } from '~/theme/typography';

export const StyledFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: theme.spacing(7),
  width: '100%',
  '& p, a': {
    color: theme.palette.grey[600],
  },
  [theme.breakpoints.down('desktop')]: {
    flexDirection: 'column',
  },
  [theme.breakpoints.down('tablet')]: {
    '& .MuiTypography-body1': {
      fontSize: pxToRem(12),
    },
    '& .MuiLink-underlineAlways': {
      fontSize: pxToRem(14),
    },
  },
}));
